/* eslint-disable no-debugger */
import { useEffect, useState } from 'react';
import useZoneData from '../../../state/zone/UseZoneData';

const useZoneMultiSelect = () => {
  const { zoneState, getZones } = useZoneData();
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (zoneState.isLoading === false && zoneState.isLoaded === false) {
      getZones();
    } else if (zoneState.isLoading === false && zoneState.isLoaded === true) {
      const zoneOptions = [];

      for (const zone of zoneState.data) {
        if (zone.zoneOrgUnitId.length > 0) {
          zoneOptions.push({ id: zone.zoneOrgUnitId, name: zone.zoneOrgUnitName });
        }
      }

      setOptions(zoneOptions);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [zoneState]);

  return {
    zoneState,
    options
  };
};

export default useZoneMultiSelect;